export const inputCellStyle = {
  width: "20px",
};
